import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Entities } from 'src/app/core/models/globals';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { HeaderService } from '../../../../core/services/header.service';
import { distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-license-server-main-panel',
  templateUrl: './license-server-main-panel.component.html',
  styleUrls: ['./license-server-main-panel.component.scss']
})
export class LicenseServerMainPanelComponent implements OnInit {

  lastRefreshedTime: Date;
  selectedLicenseServer: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navService: NavigationService,
    private headerService: HeaderService
  ) {}

  ngOnInit(): void {
    this.navService.subNavData(Entities.LicenseServer);
    this.navService.breadcrumbDeployment.pipe(distinctUntilChanged()).subscribe(x =>{
        this.selectedLicenseServer = x || this.route.snapshot.params['licenseName'] || this.route.parent.snapshot.params['licenseName'];
        this.navService.sendChildData(this.selectedLicenseServer);
      }
    );
    this.navService.sendLastUpdate(this.headerService.getUserNewDate());
    this.navService.lastUpdateTime.subscribe((x) => {
      this.lastRefreshedTime = x;
    });
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }
}
